import { trackClientEvent } from '../../../../../trackClientEvent';
export const eventKey = 'retailer_mobile-footer_desktopapp_modalsend_app_link-click';
/**
 * User sends download link sms
 */
export function trackRetailerMobileFooterDesktopappModalsendAppLinkClick(customParameterToken) {
    return trackClientEvent({
        eventKey,
        realTimeTracking: false,
        parameters: { customParameterToken },
    });
}
